import { getCommentLikeTitle } from "../notificationTitles.service";


export interface ICommentLikeTitle {
    user: string;
    commentAuthor?: string,
    isPopOut?: boolean
}

const CommentLikeTitle = ({user, commentAuthor, isPopOut}: ICommentLikeTitle ) => {
    const {className, activityInformation} = getCommentLikeTitle({user, commentAuthor, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}
        </span>
    );
};
export default CommentLikeTitle;